import React, { Component, Fragment } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { injectIntl } from "react-intl";
import { IconButton, Tooltip } from "@material-ui/core";
import { Visibility as ViewIcon, Edit as EditIcon } from "@material-ui/icons";
import {
  withModulesManager,
  withHistory,
  formatMessage,
  formatMessageWithValues,
  formatDateFromISO,
  Searcher,
} from "@openimis/fe-core";
import { fetchInsureeAccountClaimEnrollments } from "../actions";
import EnrollmentFilter from "./EnrollmentFilter";
import EnrollmentStatusBadge from "./common/EnrollmentStatusBadge";
import {
  DEFAULT_ACCOUNT_CLAIM_FILTERS,
  DEFAULT_PAGE_SIZE,
  ROWS_PER_PAGE_OPTIONS,
} from "../constants";
import { filtersToQueryParams, enrollmentRowIdentifier } from "../utils/searcher";
import {
  normalizeClaimData,
  formatDisplayValue,
} from "../utils/enrollmentData";

class InsureeAccountClaimSearcher extends Component {
  constructor(props) {
    super(props);
    this.rowsPerPageOptions = props.modulesManager.getConf(
      "fe-enrollment",
      "accountClaimEnrollmentFilter.rowsPerPageOptions",
      ROWS_PER_PAGE_OPTIONS
    );
    this.defaultPageSize = props.modulesManager.getConf(
      "fe-enrollment",
      "accountClaimEnrollmentFilter.defaultPageSize",
      DEFAULT_PAGE_SIZE
    );
  }

  fetch = (prms) => {
    this.props.fetchInsureeAccountClaimEnrollments(this.props.modulesManager, prms);
  };

  openEdit = (e) => {
    if (this.props.history) {
      this.props.history.push(`/enrollment/account-claim/${e.uuid}/edit`);
    }
  };

  headers = () => [
    "accountClaimEnrollment.chfId",
    "accountClaimEnrollment.fullName",
    "accountClaimEnrollment.dob",
    "accountClaimEnrollment.identityDocumentType",
    "accountClaimEnrollment.status",
    "accountClaimEnrollment.enrollmentDate",
    "",
  ];

  sorts = () => [
    null,
    null,
    null,
    null,
    ["status", true],
    ["dateCreated", false],
    null,
  ];

  itemFormatters = () => {
    const { modulesManager, intl, onDoubleClick } = this.props;
    return [
      (e) => formatDisplayValue(normalizeClaimData(e.claimData).chfId),
      (e) => formatDisplayValue(normalizeClaimData(e.claimData).fullName),
      (e) =>
        formatDateFromISO(
          modulesManager,
          intl,
          normalizeClaimData(e.claimData).dob
        ) || "-",
      (e) => formatDisplayValue(e.identityDocumentType),
      (e) => <EnrollmentStatusBadge status={e.status || "DRAFT"} size="small" />,
      (e) => formatDateFromISO(modulesManager, intl, e.dateCreated) || "-",
      (e) => (
        <>
          <Tooltip title={formatMessage(intl, "enrollment", "general.view") || "View"}>
            <IconButton
              size="small"
              onClick={(ev) => {
                ev.stopPropagation();
                onDoubleClick && onDoubleClick(e);
              }}
            >
              <ViewIcon fontSize="small" />
            </IconButton>
          </Tooltip>
          {e.status === "DRAFT" && (
            <Tooltip title={formatMessage(intl, "enrollment", "general.edit") || "Edit"}>
              <IconButton
                size="small"
                onClick={(ev) => {
                  ev.stopPropagation();
                  this.openEdit(e);
                }}
              >
                <EditIcon fontSize="small" />
              </IconButton>
            </Tooltip>
          )}
        </>
      ),
    ];
  };

  render() {
    const {
      intl,
      accountClaimEnrollments,
      accountClaimEnrollmentsPageInfo,
      fetchingAccountClaimEnrollments,
      fetchedAccountClaimEnrollments,
      errorAccountClaimEnrollments,
      cacheFiltersKey,
      onDoubleClick,
    } = this.props;

    const totalCount =
      accountClaimEnrollmentsPageInfo?.totalCount ??
      accountClaimEnrollments?.length ??
      0;

    return (
      <Fragment>
        <Searcher
          module="enrollment"
          cacheFiltersKey={cacheFiltersKey}
          FilterPane={EnrollmentFilter}
          items={accountClaimEnrollments}
          itemsPageInfo={{
            ...accountClaimEnrollmentsPageInfo,
            totalCount,
          }}
          fetchingItems={fetchingAccountClaimEnrollments}
          fetchedItems={fetchedAccountClaimEnrollments}
          errorItems={errorAccountClaimEnrollments}
          tableTitle={formatMessageWithValues(
            intl,
            "enrollment",
            "accountClaimEnrollment.searcher.results",
            { count: totalCount.toLocaleString() }
          )}
          rowsPerPageOptions={this.rowsPerPageOptions}
          defaultPageSize={this.defaultPageSize}
          defaultFilters={DEFAULT_ACCOUNT_CLAIM_FILTERS}
          defaultOrderBy="-dateCreated"
          fetch={this.fetch}
          rowIdentifier={enrollmentRowIdentifier}
          filtersToQueryParams={filtersToQueryParams}
          headers={this.headers}
          itemFormatters={this.itemFormatters}
          sorts={this.sorts}
          onDoubleClick={(i) => onDoubleClick && onDoubleClick(i)}
        />
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  accountClaimEnrollments: state.enrollment?.accountClaimEnrollments || [],
  accountClaimEnrollmentsPageInfo:
    state.enrollment?.accountClaimEnrollmentsPageInfo || {},
  fetchingAccountClaimEnrollments:
    state.enrollment?.fetchingAccountClaimEnrollments,
  fetchedAccountClaimEnrollments:
    state.enrollment?.fetchedAccountClaimEnrollments,
  errorAccountClaimEnrollments: state.enrollment?.errorAccountClaimEnrollments,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ fetchInsureeAccountClaimEnrollments }, dispatch);

export default withModulesManager(
  withHistory(
    connect(mapStateToProps, mapDispatchToProps)(injectIntl(InsureeAccountClaimSearcher))
  )
);
